"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const connected_icon_1 = require("@patternfly/react-icons/dist/js/icons/connected-icon");
const EmptyState_1 = tslib_1.__importDefault(require("../../../common/components/ui/uiState/EmptyState"));
const use_translation_wrapper_1 = require("../../../common/hooks/use-translation-wrapper");
const HostsDiscoveryTroubleshootingInfoLinkWithModal_1 = tslib_1.__importDefault(require("./HostsDiscoveryTroubleshootingInfoLinkWithModal"));
const HostsTableEmptyState = ({ isSingleNode = false }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(EmptyState_1.default, { icon: connected_icon_1.ConnectedIcon, title: t('ai:Waiting for host...', { count: isSingleNode ? 1 : 2 }), content: t('ai:Hosts may take a few minutes to appear here after booting.'), secondaryActions: [
            react_1.default.createElement(HostsDiscoveryTroubleshootingInfoLinkWithModal_1.default, { key: 'hosts-not-showing' }),
        ] }));
};
exports.default = HostsTableEmptyState;
//# sourceMappingURL=HostsTableEmptyState.js.map